import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { Constants } from '../../core/config/Constants'
import { ExtraService } from '../../core/services/extra.service';
import { SessionService } from '../../core/services/session.service';
import { PollService } from '../../core/services/poll.service';
import { Poll } from '../../core/models/poll-new';
import { PollListService } from '../../core/services/poll-list.service';
import { UtilityService } from '../../core/services/utility.service';

@Component({
  selector: 'app-poll-add',
  templateUrl: './poll-add.component.html',
  styleUrls: ['./poll-add.component.css'],
  providers: [SessionService, ExtraService, PollService, PollListService]
})
export class PollAddComponent implements OnInit {

  pageTitle: string = 'Poll Title';
  pageAlias: string = 'poll-form';
  disableButton = true;
  questionClass: string;
  optionClass: string;
  prop: string = '';
  eventId: string = '';
  pollId: string = '';
  eventSessionId: string = '';
  session_name: string;
  sessionList = new Array<any>();

  typeList = new Array<{ text: string }>();
  typeName: string;

  errorMessage = new Array<string>();
  classArray = new Array<string>();
  isError: boolean = false;
  message: string = '';

  reason: boolean = false;
  mquestions: boolean = false;
  reasonMandatory: boolean = false;
  pollList: Array<Poll> = new Array();
  pollIdList: Array<any> = new Array();

  eventLists: boolean = true;

  poll = new Poll();

  constructor(private pollListService: PollListService, private extraService: ExtraService, private route: ActivatedRoute, private router: Router,
    private sessionService: SessionService, private pollService: PollService, private utilityService: UtilityService) {
  }

  ngOnInit() {
    this.typeList = [
      { text: 'Type 1' },
      { text: 'Type 2' },
    ];
    this.addItem();
    this.addItem();
    this.extraService.changeStateofSideBarButton(true);
    this.extraService.changeSideBar(true);
    this.route.queryParams.subscribe(params => {
      let id = params['eventId'];
      let pollID = params['pollId'];
      let SESSION_ID = params['sessionId'];
      if (SESSION_ID) {
        this.eventSessionId = SESSION_ID;
      } if (id) {
        this.eventId = id;
        let speakerId = null;
        this.setPollList(id);
        this.extraService.setCurrentEventId(id);
      } if (pollID) {
        this.pollId = pollID;
        this.setPollDetails(this.eventId, this.pollId);
      }
    });
  }

  setPollList(id) {
    this.message = null;
    var x = this.pollService.getPollList(id)
    x.snapshotChanges().subscribe(list => {
      //this.contactIdList = new Array();
      this.pollList = new Array();
      this.pollIdList = new Array();
      list.forEach(element => {
        var y = element.payload.toJSON();
        y["$key"] = element.key;
        if (this.pollIdList.indexOf(element.key + "") == -1) {
          this.pollIdList.push({ eventLists: this.eventLists = true });
          this.pollList.push(y as Poll);
        }
      });
    });
  }

  addItem() {
    // this.poll.options.push('');
    // this.classArray.push('');
  }

  trackByIndex(index: number, value: number) { return index; }

  removeItem(index) {
    // if (this.poll.options.length > 2) {
    //   this.poll.options = this.poll.options.filter((val, i) => i != index);
    //   this.classArray = this.classArray.filter((val, i) => i != index)
    // }
  }

  receiveSession($event) {
    if ($event.prop == 'event') {
      this.prop = $event.prop;;
      this.poll.eventId = this.eventId;
      this.poll.sessionId = null
    } if ($event.prop == 'session') {
      this.poll.eventId = this.eventId;
      this.prop = $event.prop;
      this.poll.sessionId = $event.sessionId;
    }
  }

  setType(value) {
    this.poll.type = this.typeName = value;
  }

  setPollDetails(eventId, pollId) {
    this.pollService.getPollDetail(eventId, pollId).subscribe(event => {
      if (event) {
        this.poll = event;
        if (event.type) { this.typeName = event.type }
        if (event.sessionId) { this.eventSessionId = event.sessionId; }
        // if (!this.poll.options || this.poll.options.length < 1) {
        //   this.poll.options = new Array();
        //   this.addItem();
        // }
      }
    });
  }

  submit() {
    this.clearClasses();
    this.message = null;
    this.poll.eventId = this.eventId;
    if (this.validate()) {
      if (!this.pollId) {
        if (this.errorMessage.length == 0) {
          let email = this.utilityService.getUserEmail();
          this.poll.createdBy = email;
          // for (var i = 0; i < this.poll.options.length; i++) {
          //   if (this.poll.options[i] == "") {
          //     this.poll.options[i] = null;
          //   }
          // }
          this.add();
        }
      } else {
        if (this.errorMessage.length == 0) {
          // for (var i = 0; i < this.poll.options.length; i++) {
          //   if (this.poll.options[i] == "") {
          //     this.poll.options[i] = null;
          //   }
          // }
          this.update();
        }
      }
    } else {
      this.isError = true;
    }

  }

  checkPollReleaseType(event) {
    if (event.target.value === 'IMMEDIATELY') {
      this.poll.isReleased = true;
    } else {
      this.poll.isReleased = false;
    }
  }

  validate() {
    let valid = true;
    this.isError = false;
    this.errorMessage = new Array<string>();
    if (this.reason) {
      // this.poll.isReasonAvailable = this.reason;
    } else { }
    if (this.reasonMandatory) {
      // this.poll.isReasonMandatory = this.reasonMandatory;
    } else { }
    if (this.prop == 'session' && !this.poll.sessionId) {
      this.isError = true;
      this.errorMessage.push("Please select session from dropdown");
      valid = false;
    } else {

    }

    // if (this.poll.options.length > 0) {
    //   for (var i = 0; i < this.poll.options.length; i++) {
    //     if (this.poll.options[i].length == 0) {
    //       if (i == 1 || i == 0) {
    //         this.isError = true;
    //         valid = false;
    //         this.optionClass = "form-control fieldWithErrors";
    //         this.errorMessage.push("Min 2 poll options needed");
    //       } else {

    //       }
    //     }
    //   }
    // }

    // if (this.poll.Question == null) {
    //   this.isError = true;
    //   this.errorMessage.push("Poll question can not be empty");
    //   this.questionClass = "form-control fieldWithErrors";
    //   valid = false;
    // }
    return valid;
  }

  clearClasses() {
    this.questionClass = 'form-control';
    this.optionClass = 'form-control';
  }

  add() {
    this.disableButton = false;
    this.poll.position = this.pollList.length;
    let poll = this.poll;
    let pollkey = this.pollService.addPollDetail(this.eventId, poll);
    if (pollkey) {
      this.message = 'Added Successfully';
      setTimeout(function () {
        this.disableButton = true;
        this.message = null;
        this.router.navigate([Constants.POLL_FORM, this.eventId]);
      }.bind(this), 2000);
    }
  }

  update() {
    this.disableButton = false;
    let poll = this.poll;
    this.pollService.updatePollDetail(this.eventId, this.pollId, poll).then(res => {
      this.message = 'Update Successfully';
    }).catch(error => {
      this.errorMessage = error.message;
    });
    setTimeout(function () {
      this.message = null;
      this.disableButton = true;
      this.router.navigate([Constants.POLL_FORM, this.eventId]);
    }.bind(this), 2000);
  }

}



// WEBPACK FOOTER //
// /app/src/app/event/poll-add/poll-add.component.ts